<template>
  <div class="fullscreen-video-container">
    <div class="fullscreen-video-close">
      <button
        type="button"
        class="circled interactive grey close-modal outline"
        @click="closeVideo"
      >
        <svg-icon id="cross"></svg-icon>
      </button>
    </div>
    <div class="iframe-container">
      <iframe @load="updateVideoForVimeo" id="modal-iframe" :src='"https://player.vimeo.com/video/" + data.videoCode + "?version=3"' frameBorder="0" allowFullScreen  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closeVideo() {
      this.$emit('cancel');
    },
    updateVideoForVimeo() {
      var iframe = document.getElementById('modal-iframe');
      var player = new Vimeo.Player(iframe);

      // Get Dimensions from Vimeo Player
      Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(dimensions => {
        const [width, height] = dimensions;
        const aspectRatio = (width/height).toString();
        iframe.parentElement.style.setProperty('max-width', 'calc((98vh - 220px) * (' + aspectRatio + '))')
      });
    },
  },
  mounted() {

  }
}
</script>
